import { store } from "../../redux/store";
import { PAGE_TEMPLATES } from "./templates";

const getDynamicPageBasePaths = () => {
    const dynamicPagesData = store.getState().dynamicPagesData;
    const paths = {};

    for (const key of Object.keys(PAGE_TEMPLATES)) {
        if (!["PRODUCT_OVERVIEW", "PRODUCT_DETAIL"].includes(key)) continue;

        paths[key] = dynamicPagesData[PAGE_TEMPLATES[key]];
    }

    return paths;
};

export const DYNAMIC_PAGE_PATHS = {
    ...getDynamicPageBasePaths(),
};

export const DYNAMIC_PAGE_QUERY_KEYS = {
    PRODUCT_OVERVIEW: "category",
    PRODUCT_DETAIL: "product",
};

export const STATIC_PAGE_PATHS = {
    // HOME is intentionally absent: it is the current site's base and resolved dynamically
    // in getStaticPageLink (utils/links.js).
    CART: "/cart",
    CHECKOUT: "/checkout",
    // The remaining flone "other" pages, served by their Magnolia twins under pages/magnolia
    // so they get the shop's header/footer from BaseLayout instead of flone's LayoutOne.
    COMPARE: "/compare",
    WISHLIST: "/wishlist",
    LOGIN_REGISTER: "/login-register",
    MY_ACCOUNT: "/my-account",
};
